import { z } from 'zod';

export const itemRecorrenciaSchema = z.object({
  produtoId: z.string().min(1, 'Produto ID é obrigatório'),
  quantidade: z.number().int().positive('A quantidade deve ser maior que zero'),
  precoUnitario: z.number().positive('O preço unitário deve ser maior que zero'),
});

export const recorrenciaSchema = z.object({
  id: z.string().optional(),
  clienteId: z.string().min(1, 'Cliente ID é obrigatório'),
  itens: z.array(itemRecorrenciaSchema).min(1, 'A recorrência deve ter pelo menos um item'),
  periodicidade: z.enum(['SEMANAL', 'QUINZENAL', 'MENSAL']),
  diaBase: z.number().int().min(1).max(31),
  dataInicio: z.string(),
  dataFim: z.string().optional(),
  ativa: z.boolean().optional().default(true),
  ultimaOcorrenciaGerada: z.string().optional(),
});

export type RecorrenciaSchema = z.infer<typeof recorrenciaSchema>;
export type ItemRecorrenciaSchema = z.infer<typeof itemRecorrenciaSchema>;
